export const defaultCheckboxColors = {
  indeterminateDisabled: '#00003d',
  checkedDisabled: '#00003d',
  unCheckedDisabled: '#353b60',
  indeterminate: '#DFE0E5',
  checked: '#00003D',
  unChecked: '#353b60',
  hoverColor: '#353b60'
};